﻿import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup, FormControl, NgForm, ReactiveFormsModule } from '@angular/forms';
import { VoiceService } from '../../_services/voice/voice';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { ViewChild, ViewChildren, QueryList } from '@angular/core';
import { Constants } from '../../../../_utils/Constants';
import { APILoginService } from '../../_services/login/API-login';
import { APIEntityService } from '../../_services/entity/API-entity';
import { LoginComponent } from '../login/login.component';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import * as crypto from 'crypto-js';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { APIConstants } from '../../../../_config/restapis';
import { map } from 'rxjs/operators';
import { formatDate } from '@angular/common';
import { MustMatch } from '../../../../_helpers/must-match-validator';
import * as CryptoJS from 'crypto-js';
import { varPattern } from './varPattern';
import { APIConsentService } from '../../_services/consent/API-consent';
import { ChangeDetectorRef } from '@angular/core';


const today = new Date();
var time_today = today.getTime();
var refid = "CID_" + time_today;
const entityId = "EID_" + time_today;


let now = new Date();



export interface communicationtypelist {
  value: string;
  viewValue: string;
}

export interface calltypelist {
  value: string;
  viewValue: string;
}

export interface languagelist {
  value: string;
  viewValue: string;
}
export interface languagelistother {
  value: string;
  viewValue: string;
}

export interface categorylist {
  value: string;
  viewValue: string;
}

export interface novariablelistlist {
  value: string;
  viewValue: string;
}




@Component({
  selector: 'app-voice-Template-reg-by-pe',
  templateUrl: './voice-Template-reg-by-pe.component.html',
  styleUrls: ['./voice-Template-reg-by-pe.component.css']
})
export class VoiceContentTemplateRegComponent implements OnInit {


  email: any;
  disableForm: boolean = false;
  mobileno: any;
  pePrefix: string = "";
  identifiedVal: string = "";
  showOTPfields: boolean;
  selectedVaribles: any = 0;
  getValue: any;
  public principalEntityId: any;
  dataSourceHeaderSummary: MatTableDataSource<any>;
  showErrorFlag: boolean = false;
  verifiedCSTempID: any;
  cstempids = [];
  selectedOption!: string;
  containsVar: any;
  showvariablealert: boolean = false;
  
  constructor(private fb: FormBuilder,
    private es: APILoginService,
    private vs: VoiceService,
    private ls: APIEntityService,
    private cst: APIConsentService,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
    private _route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private router: Router) {

     

    this.checkEntityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);

  }
  rootVal: string = "";
  response: any;
  templateregForm: FormGroup;
  selectedValue: String;
  checkEntityId: String;
  telelist: any;
  industrylist: any;
  sectorlist: any;
  public Entity_ID_Existing = 'N';
  public govtlistdiv: boolean = false;
  with_variable: boolean = false;
  without_variable: boolean = false;
  // csTempIDRequired: boolean = true;
  get f() { return this.templateregForm.controls; }

  

  uploader: string[];
  public entity_id;
  public industry_category;
  public Organization;
  
  myfiles: any[] = [];
  public newHeaderSummaryDLT: any;

   

  noRecord4: any;

  photoName: any;
  fileExtension: any;
  fileExtensionError: boolean = false;
  fileExtensionMessage: any;
  photoContent: any;
  fileSizeError1: boolean = false;
  fileSizeError2: boolean = false;
  selectedValueCat: String;
  entCheck;
  submitted: boolean = false;
  attachmentList: any = [];
  headerlist: any = [];
  languageshow: boolean = true;
  languageothershow: boolean = false;
  
  warningForNotMatchingEnitity: boolean = false;
  makeRead: boolean = false;
  showPeTmRemainingFeilds: boolean = false;
  public entityPresentFlag: boolean = true;
  categoryshow: boolean = false;
  categoryhide: boolean = true;
  VerifiedCSTemp: boolean = false
  csTempName: any;
  csTempContent: any;

  no_variables: number = 0;  


  communicationtypelistitems: communicationtypelist[] = [
    { value: 'P', viewValue: 'Promotional' },
    { value: "S", viewValue: "Service" },
    { value: "T", viewValue: "Transactional" },
  ];

  calltypelistitems: calltypelist[] = [
    { value: 'RV', viewValue: 'Recorded call with Variable' },
    { value: 'RWOV', viewValue: 'Recorded call without Variable' },
    { value: 'P2P', viewValue: 'Person to Person call' },
  ];

  languagelistitems: languagelist[] = [
    { value: 'English', viewValue: 'English' },
    { value: 'Hindi', viewValue: 'Hindi' },
  ];

 
  categorylistitems: categorylist[] = [
    { value: '1', viewValue: 'Banking / Insurance / Financial Products / Credit cards' },
    { value: '2', viewValue: 'Real Estate' },
    { value: '3', viewValue: 'Education' },
    { value: '4', viewValue: 'Health' },
    { value: '5', viewValue: 'Consumer Goods and automobiles' },
    { value: '6', viewValue: 'Communication / Broadcasting / Entertainment / IT' },
    { value: '7', viewValue: 'Tourism / Leisure' },
    { value: '8', viewValue: 'Food and Beverages' },

  ];

  novariablelistlistitems: novariablelistlist[] = [
    { value: '0', viewValue: '0' },
    { value: '1', viewValue: '1' },
    { value: '2', viewValue: '2' },
    { value: '3', viewValue: '3' },
    { value: '4', viewValue: '4' },
    { value: '5', viewValue: '5' },
    { value: '6', viewValue: '6' },
    { value: '7', viewValue: '7' },
    { value: '8', viewValue: '8' },
    { value: '9', viewValue: '9' },
    { value: '10', viewValue: '10' },
    { value: '11', viewValue: '11' },
    { value: '12', viewValue: '12' },
    { value: '13', viewValue: '13' },
    { value: '14', viewValue: '14' },
    { value: '15', viewValue: '15' },
    { value: '16', viewValue: '16' },
    { value: '17', viewValue: '17' },
    { value: '18', viewValue: '18' },
    { value: '19', viewValue: '19' },
    { value: '20', viewValue: '20' }
  ];

  ngOnInit() {

    this.templateregForm = this.fb.group({
      Organization: ['',],
      industry_category: ['',],
      entity_id: ['',],
      sector: ['',],
      communication_type: ['', [Validators.required]],
      category: ['', [Validators.required]],
      header_list: ['', [Validators.required]],
      content_type: ['', [Validators.required]],
      language: ['', [Validators.required]],
      template_name: ['', [Validators.required]],
      

      selectedOption: new FormControl(''),
      dialerCalls: new FormControl(false),
    
      mandatory: ['',],

      VoiceTemp_Content: ['', [Validators.maxLength(1500), Validators.minLength(5)]],
      docname: [''],
      Entity_ID_Existing: ['',],
      uploader: ['',],
      desc_template: ['', [Validators.minLength(5), Validators.maxLength(500)]],
      type_of_call: ['', [Validators.required]],
      justification: ['',],  
      csTempID: [''],
      cstemplate_id1: ['',],
      csTempName: [''],
      csTempContent: [''],
      //Added for sample Content
      sample_content: ['', [Validators.required, Validators.maxLength(4590), Validators.minLength(5)]],
      robocb: ['', Validators.required],
      autodiallercb: ['',],

      
    }, {
      validator: varPattern('VoiceTemp_Content', 'no_variables')
    });//end of templateregForm
    
    this.valuechange();
   
   // console.log("-EntityID-", this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID))
    let data = {
     
      entity_id: this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID)
    }
    this.cst.fetchCSTID(data).subscribe((res) => {
     
      this.cstempids = res.data
      this.cstempids.push({ cstemplate_id: 'Others' })
      
      //console.log("this.cstempids", this.cstempids)
    })

    let type_of_call = this.templateregForm.get("type_of_call").value;
    //console.log("----type_of_call", type_of_call);
    

  }//end of oninit




 

  displayVars(event) {
    console.log("event value", event.target.value)
    //console.log("event", event)
    this.no_variables = (event.target.value.match(/{#var#}/gi) || []).length

    //console.log("no_variables", this.no_variables)


    //justification start
    if (this.no_variables > 0) {
      this.with_variable = true
      this.without_variable = false
    } else {
      this.without_variable = true;
      this.with_variable = false;

    }

    //console.log("---------- this.templateregForm.controls['robocb'].valu-----", this.templateregForm.controls['robocb'].value)
    this.templateregForm.controls['robocb'].setValue(false);
    
    if (this.no_variables > 2) {
      //console.log("----------no_variables-----------", this.no_variables)
      this.templateregForm.controls['justification'].setValidators([Validators.required, Validators.minLength(10), Validators.maxLength(100)])
      this.templateregForm.controls['justification'].updateValueAndValidity()
    }
    else {
      this.templateregForm.controls['justification'].clearValidators()
      this.templateregForm.controls['justification'].updateValueAndValidity()
    }
    //justification end
  }


  //Added for text validation

  changeCSText(id) {
    console.log(id)
    this.templateregForm.controls["cstemplate_id1"].enable();
    this.templateregForm.controls['cstemplate_id1'].setValidators([Validators.required, Validators.pattern("^([0-9]{19})$"), Validators.maxLength(19), Validators.minLength(19)]);
    this.templateregForm.controls['cstemplate_id1'].updateValueAndValidity();
  }
  clearCSTID() {
    this.templateregForm.controls['cstemplate_id1'].reset();
   
    this.templateregForm.controls["csTempID"].reset();
    this.VerifiedCSTemp = false;
    // this.verifiedCSTempID = "";
    this.templateregForm.controls['cstemplate_id1'].clearValidators();
    this.templateregForm.controls['cstemplate_id1'].updateValueAndValidity();
    // this.templateregForm.controls['csTempID'].clearValidators();
    // this.templateregForm.controls['csTempID'].updateValueAndValidity();
  }
  //Added ends here

  changeCSTID(event: any) {
    
    let csTempID = event.value
    console.log("-event value- : ", csTempID)
  

    if (csTempID == "Others") {
      
      console.log("-cstmp- : ", csTempID)
      this.templateregForm.controls["cstemplate_id1"].enable();
      this.templateregForm.controls['cstemplate_id1'].setValidators([Validators.required, Validators.pattern("^([0-9]{19})$")]);
      this.templateregForm.controls['cstemplate_id1'].updateValueAndValidity();
    }
    else {
      this.templateregForm.controls['cstemplate_id1'].clearValidators();
      this.templateregForm.controls['cstemplate_id1'].updateValueAndValidity();
    }

    let communication_type = this.templateregForm.get("communication_type").value;

    if (csTempID == this.verifiedCSTempID) {
      this.VerifiedCSTemp = true
      
    }
    else {
      this.VerifiedCSTemp = false;

    }

  
    // this.templateregForm.controls['csTempID'].clearValidators();

    // this.templateregForm.controls['csTempID'].updateValueAndValidity();

    // this.csTempIDRequired = false;



  }
  showCSTinfo() {

    this.$modal.promptModal({
      title: "Consent Template Name: " + this.csTempName,
      msg: "Consent Template Content: " + this.csTempContent
    });
  }
  verifyCsTempID() {

    let csTempID = this.templateregForm.get("csTempID").value;

    if (this.templateregForm.controls["csTempID"].valid && csTempID != null && csTempID != '') {

      let data = {}
      if (csTempID != 'Others') {
        data = {
          csTempID: csTempID,
          entity_id: this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID)
        }
      }
      else {
        csTempID = this.templateregForm.get("cstemplate_id1").value;
        data = {
          csTempID: this.templateregForm.get('cstemplate_id1').value,
          entity_id: this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID)

        }
      }

      
      this.ls.verifyCsTempID(data)
        .subscribe(r => {
          if (r.status == "success") {
            this.verifiedCSTempID = csTempID
           
            this.csTempName = r.message.CST_Name;
            this.csTempContent = r.message.CST_Content;
            this.VerifiedCSTemp = true;

          }
          else if (r.status == "failed" && r.message == "Already linked") {
            this.$modal.errorModal({
              title: 'Voice Template Registration',
              msg: 'The consent Template ID is already linked with an Active Content Template'
            });
          }
          else if (r.status == "failed" && r.message == "Not assigned") {
            this.$modal.errorModal({
              title: 'Voice Template Registration',
              msg: 'The consent Template id updated is incorrect or not active/mapped against your entity, please retry with a valid ID (Refer Entity Consent Template Report)'
            });
          }
          else if (r.status == "failed" && r.message == "Error") {
            this.$modal.errorModal({
              title: 'Voice Template Registration',
              msg: 'Error while retrieving data from DB'
            });
          }
          else {
            this.$modal.errorModal({
              title: 'Voice Template Registration',
              msg: 'Some Error Occured'
            });
          }
        })
    }
  }
  onChangeEvent(event) {
    this.selectedVaribles = event.value;

  }

  onChangeTemplate(event) {
    if (event.value == 'Text') {
      
      this.templateregForm.controls['language'].setValue('English');
      
    } else {
      
      this.templateregForm.controls['language'].setValue('Hindi');
       
    }
  }

  async onchangecommtype(event) {
    this.templateregForm.controls['header_list'].reset();

    this.headerlist = [];
    console.log("communication type..." + event.value);

    console.log("-------this.checkEntityId--------", this.checkEntityId)
    let data = {
      "entity_id": this.checkEntityId,
      "htyp": event.value
    }
    await this.vs.fetchvoicehdrforPE(data).subscribe(val => {
      this.getValue = val.data;

      if (event.value == "Promotional") {
        this.templateregForm.controls['category'].clearValidators();
        this.templateregForm.controls['category'].updateValueAndValidity();


        this.getValue.forEach(element => {
          // console.log("ELEMENT", element)


          if (element['htyp'] == "P") {
            //console.log("----element.cli----", element.cli)
            this.headerlist.push(element.cli)
          }
        });
        console.log("HEEEEEADERS list", this.headerlist)

        this.templateregForm.controls['category'].setValidators([Validators.required]);
        this.templateregForm.controls['category'].updateValueAndValidity();

        this.templateregForm.controls['csTempID'].setValidators([Validators.required]);
        this.templateregForm.controls['csTempID'].updateValueAndValidity();
        this.categoryshow = true;
        this.categoryhide = false;
      }
      ////////////////rqt_5 start////////////////////
      else {
        this.templateregForm.controls['category'].clearValidators();
        this.templateregForm.controls['category'].updateValueAndValidity();


        this.getValue.forEach(element => {
          //console.log("ELEMENT", element)


          if (element['htyp'] == "S" || element['htyp'] == "T")
            this.headerlist.push(element.cli)
        });
       // console.log("HEEEEEADERS list", this.headerlist)

        this.templateregForm.controls['category'].setValidators([Validators.required]);
        this.templateregForm.controls['category'].updateValueAndValidity();

        this.templateregForm.controls['csTempID'].clearValidators();
        this.templateregForm.controls['csTempID'].updateValueAndValidity();
        this.categoryshow = true;
        this.categoryhide = false;
      }
    });
  }

  resetinfo() {
    this.router.navigateByUrl('/voice-templates-by-pe');
  }



  valuechange() {
    let data = {
      "entity_id": this.checkEntityId,
    }
    this.ls.getContentEntityDetails(data)
      .subscribe(r => {
        try {
          this.templateregForm.controls['entity_id'].setValue(r[0].id);
          this.templateregForm.controls['entity_id'].disable();
         
          if (r[0].etype === 'P') {
            this.templateregForm.controls['industry_category'].setValue('private');
            this.templateregForm.controls['industry_category'].disable();
          } else if (r[0].etype == 'G') {

            this.templateregForm.controls['industry_category'].setValue('Government');
            this.templateregForm.controls['industry_category'].disable();
          }
          else if (r[0].etype == 'S') {
            this.templateregForm.controls['industry_category'].setValue('SEBI');
            this.templateregForm.controls['industry_category'].disable();
          } else if (r[0].etype == 'U') {
            this.templateregForm.controls['industry_category'].setValue('Public Limited Company');
            this.templateregForm.controls['industry_category'].disable();
          } else if (r[0].etype == 'O') {
            this.templateregForm.controls['industry_category'].setValue('Others');
            this.templateregForm.controls['industry_category'].disable();
          }
          else {
            this.templateregForm.controls['industry_category'].setValue('');
            this.templateregForm.controls['industry_category'].disable();
          }

          this.templateregForm.controls['Organization'].setValue(r[0].name);
          this.templateregForm.controls['Organization'].disable();

          this.makeRead = true;
        }
        catch (e) {
          this.warningForNotMatchingEnitity = true;
        }
      })
  }

  fileEvent(event): any {

    var file = event.target.files[0];
    this.photoName = file.name;

    var allowedExtensions =
      ["jpg", "pdf"];
    this.fileExtension = this.photoName.split('.').pop();

    if (this.isInArray(allowedExtensions, this.fileExtension)) {
      this.fileExtensionError = false;
      this.fileExtensionMessage = ""
      alert("Invalid File 1 formate");
    } else {
      this.fileExtensionMessage = "Only photos allowed!!"
      alert("Invalid File 2 formate");
      this.fileExtensionError = true;
    }

    if (file) {
      var reader = new FileReader();
      reader.onloadend = (e: any) => {
        var contents = e.target.result;
        this.photoContent = contents;
      }
      reader.readAsDataURL(file);
    } else {
      alert("Failed to load file");
    }
  }

  
  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }


  onChangeFileUpload(event) {

    this.myfiles = event.target.files;
    var file = event.target.files[0];
    this.photoName = file.name;
    let fileNameArr = this.photoName.split('.')
    if (fileNameArr.length > 2) {
    
      this.$modal.errorModal({
        title: 'Voice Template Registration',
        msg: 'File with double extension is not allowed!'
      })
      this.resetKYC()
    } else {
      console.log("the size is ", file.size)
      if (file.size > 5000000) {
       // console.log("The size is more ")
        this.fileSizeError1 = true;
      }
      else {
        this.fileSizeError1 = false;
      }
      if (file.size <= 0) {
        //console.log("The size is less ")
        this.fileSizeError2 = true;
      }
      else {
        this.fileSizeError2 = false;
      }
      var allowedExtensions =
        ["jpg", "pdf"];
      this.fileExtension = this.photoName.split('.').pop();
      console.log("this.photoName   ----------- ", this.photoName)

      if (this.isInArray(allowedExtensions, this.fileExtension)) {
        this.fileExtensionError = false;
        this.fileExtensionMessage = ""
      } else {
        this.fileExtensionMessage = "Only photos allowed!!"
        this.fileExtensionError = true;
      }

      if (file) {
        var reader = new FileReader();
        reader.onloadend = (e: any) => {
          var contents = e.target.result;
          this.photoContent = contents;
        }
        reader.readAsDataURL(file);
      } else {
        alert("Failed to load file");
      }
     // console.log("this is file extension error", this.fileExtensionError);
    }
  }


  onChangeRootVal() {
    this.rootVal = this.pePrefix + this.identifiedVal;
  }

  onSubmit() {

  
    if (this.templateregForm.controls["justification"].invalid) {
      this.$modal.errorModal({
        title: 'Voice Template Registration',
        msg: 'Please enter Variable Justification'
      });
      return;
    }

    let errors = this.templateregForm.get("VoiceTemp_Content").value;
    let csTempID = this.templateregForm.get("csTempID").value || "";
    
   // console.log("this.templateregForm.controlsinvalid ", this.templateregForm.controls["cstemplate_id1"])
    if (csTempID == 'Others' && !this.templateregForm.controls["cstemplate_id1"].invalid) {
      //  if (csTempID == 'Others') {

      this.templateregForm.controls['cstemplate_id1'].setValidators([Validators.required, Validators.minLength(19), Validators.maxLength(19)])
      this.templateregForm.controls['cstemplate_id1'].updateValueAndValidity()
      csTempID = this.templateregForm.get('cstemplate_id1').value || "";
    }

    let communication_type = this.templateregForm.get("communication_type").value;

    //console.log("this.templateregForm", this.templateregForm)
    if (errors.trim().length == 0) {


      this.$modal.errorModal({
        title: 'Voice Template Registration',
        msg: 'Please enter valid Template content'
      });
      this.showErrorFlag = true;

      return;
    }
    if (this.templateregForm.controls["csTempID"].invalid) {
      this.$modal.errorModal({
        title: 'Voice Template Registration',
        msg: 'Please enter valid Consent Template ID'
      });
      return;
    }
    if (this.templateregForm.controls["VoiceTemp_Content"].invalid) {
      this.$modal.errorModal({
        title: 'Voice Template Registration',
        msg: 'Please enter valid Template content'
      });
      return;
    }

    if (this.templateregForm.controls["type_of_call"].invalid) {
      this.$modal.errorModal({
        title: 'Voice Template Registration',
        msg: 'Please select the Type of Call'
      });
      return;
    }
    const selectoption = this.templateregForm.controls["type_of_call"].value
    if ((selectoption === 'Recorded With Variables' || selectoption === 'Recorded without Variable' || selectoption === 'P2P Auto Dialer') && this.templateregForm.controls['robocb'].invalid) {
      this.$modal.errorModal({
        title: 'Voice Template Registration',
        msg: 'Please select the checkbox'
      });
      return;
    }
    else {
      this.templateregForm.controls['robocb'].clearValidators();
      this.templateregForm.controls['robocb'].updateValueAndValidity();
    }

  
    //console.log("csTempID *********** ", csTempID)
    if (this.verifiedCSTempID != csTempID && csTempID.trim().length != 0) {
      console.log("-------this.verifiedCSTempID--------", this.verifiedCSTempID)
      console.log("-------csTempID-------", csTempID)
      this.$modal.errorModal({
        title: 'Voice Template Registration',
        msg: 'Please Verify the Consent Template ID to proceed'
      });
      return;
    }
    

    if (this.templateregForm.invalid || this.fileExtensionError || this.fileSizeError1 || this.fileSizeError2) {
      //console.log("this.templateregForm.invalid *** ", this.templateregForm.invalid, this.fileExtensionError, this.fileSizeError1, this.fileSizeError2)
      alert("Please fill all Mandatory Fields");
      this.disableForm = true;
      let invalid = [];
      let controls = this.templateregForm.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(name);
        }
      }
      return;
    }
    if (this.entCheck === 'No') {
      console.log("entCheck-------------")
      this.Entity_ID_Existing = 'N';
      this.entity_id = this.templateregForm.get("entity_id").value;
      this.VoiceTemplateRegistration(this.Entity_ID_Existing);
    }

    else {
      this.onChangeRootVal();
      console.log("entCheck--else----------")
      this.Entity_ID_Existing = 'Y';
      this.submitted = true;
      if (this.templateregForm.invalid) {
        console.log("entCheck--else---this.templateregForm.invalid) if -------")
        return;
      }
      else {
        this.VoiceTemplateRegistration(this.Entity_ID_Existing);
      }
    }
  }

  resetKYC() {
    this.fileExtensionError = false;
    this.fileSizeError1 = false;
    this.fileSizeError2 = false;
    this.templateregForm.controls['uploader'].reset();
  }

  previewinfo() {
    console.log("called")
    let name = "Guidelines "
    let contentinfo = "Please use the variable as shown below and use \\n for new line  :-  i. Transfer your outstanding Credit and debt to personal loan with interest rate as low as {#var#} ii. Dear Customer, your order number {#var#} has been dispatched. TnC apply. "


    this.$modal.promptModal({
      title: name,
      msg: contentinfo
    });
  }

  VoiceTemplateRegistration(Entity_ID_Existing) {

    console.log("------------in registration------")

    let entity_id = this.templateregForm.get("entity_id").value;
    let industry_category = this.templateregForm.get("industry_category").value;
    let Organization = this.templateregForm.get("Organization").value;
    let communication_type = this.templateregForm.get("communication_type").value;
    let category = this.templateregForm.get("category").value;
    let header_list = this.templateregForm.get("header_list").value;
    let content_type = this.templateregForm.get("content_type").value;
    let language = this.templateregForm.get("language").value;
    let template_name = this.templateregForm.get("template_name").value;
    let no_variables = this.no_variables.toString();
    let VoiceTemp_Content = this.templateregForm.get("VoiceTemp_Content").value;
    let docname = this.templateregForm.get("docname").value;
    let desc_template = this.templateregForm.get("desc_template").value;
    let justification = this.templateregForm.get("justification").value;
    let type_of_call = this.templateregForm.get("type_of_call").value;
    //Added
    let CSTempID: any;
    if (this.templateregForm.get("csTempID").value == "Others") {
      CSTempID = this.templateregForm.get("cstemplate_id1").value || "";
    }
    else {
      CSTempID = this.templateregForm.get("csTempID").value || "";
    }

    let CST_Name = this.templateregForm.get("csTempName").value;
    let CST_Content = this.templateregForm.get("csTempContent").value;


    console.log("communication_type ---------- ", communication_type)


    const templateregForm: FormData = new FormData();
    templateregForm.append('entity_id', entity_id);
    templateregForm.append('industry_category', industry_category);
    templateregForm.append('Organization', Organization);
    templateregForm.append('communication_type', communication_type);
    templateregForm.append('category', category);
    templateregForm.append('language', language);

    console.log("header_list", header_list)
    templateregForm.append('header_list', header_list);
    templateregForm.append('content_type', content_type);
    templateregForm.append('template_name', template_name);
    templateregForm.append('no_variables', no_variables);
    templateregForm.append('justification', justification);
    templateregForm.append('VoiceTemp_Content', VoiceTemp_Content);
    templateregForm.append('docname', docname);
    templateregForm.append('desc_template', desc_template);
    templateregForm.append('type_of_call', type_of_call)
    console.log("CSTempID ", CSTempID)
    templateregForm.append('CSTempID', CSTempID);

    if (CSTempID != null && CSTempID != '' && CSTempID != 'undefined') {
      templateregForm.append('CST_Name', this.csTempName);
      templateregForm.append('CST_Content', this.csTempContent);
    }


    const file1: any = document.getElementById('uploader');


    console.log("file :", file1.files[0]);
  

    templateregForm.append('file1', file1.files[0]);
    templateregForm.append('Create_Date', formatDate(Date.now(), 'yyyy-MM-dd', 'en-US', '+0530'));
    templateregForm.append('Entity_Class', "PE");

 
    templateregForm.append('Sample_Content', this.templateregForm.get("sample_content").value);

    // console.log("templateregForm         ", templateregForm)
    // console.log("this.templateregForm        ", this.templateregForm.value)
    this.vs.voicetemplateregistration(templateregForm)
      .subscribe(r => {
        try {

          if (r.status == "success") {

            this.$modal.successModal({
              title: 'Voice Template Registration',
              msg: 'Your request for new Template is registered with us and is pending for approval. We shall revert to you in 24 hours. ' + ' Your Id ' + r.insertInMongo.VoiceTemp_Ref_No
            });
            this.router.navigateByUrl('/voice-templates-by-pe');
          } else {
            if (r.insertInMongo == "duplicate") {
              this.$modal.errorModal({
                title: 'Voice Template Registration',
                msg: 'Template name already exists, Please enter another name'
              });

            }
            else if (r.insertInMongo == "pending") {
              this.$modal.errorModal({
                title: 'Voice Template Registration',
                msg: 'Template name is already registered with us and pending for approval'
              });

            }

            else if (r.insertInMongo == "modification") {
              this.$modal.errorModal({
                title: 'Voice Template Registration',
                msg: 'You have registered this template name with us and is sent back for modification. Please modify the template as per the registrar comments communicated to you'
              });

            }

          }


         
        }

        catch (e) {

          console.log("catch in registration", e);
        }

      });
  }


}   